import { Text, Link } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'

export const QuestOneTime = () => {
  const { t } = useTranslation()

  return (
    <>
      <Text mb="8px" color="black" fontWeight="600">
        {t('One time quests')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('This is a one time only task. You can earn EXP by only completing this quest once!')}
      </Text>
      <Text fontSize="13px" color="darkGrey">
        {t('You may earn more or less than this amount depending on your team’s health meter. ')}
        <Link
          inline
          underline="always"
          href="https://docs.vvs.finance/product-guides/vvs-gotchi/quest-page"
          target="_blank"
          rel="noreferer noopener"
        >
          {t('Learn more')}
        </Link>
      </Text>
    </>
  )
}
